import {
  React,
  useNavigate,
  useRef,
  useEffect,
  memo,
  useLocation,
  Button,
  toast,
  useState,
  Box,
  LayoutSidebar,
  LayoutFooter,
  LayoutSelectionSlider,
  AddPostMiddleForm,
  useCreatePostMutation,
  LoadingSpinner,
  GetCookie,
} from "../../../Libraries/Post/AddNewPost/Parent/index";

const AddNEWPOST = () => {
  const [createPost, { isLoading }] = useCreatePostMutation();
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setdata] = useState({
    selectedLayout: location.state?.ser_layout_id
      ? location.state?.ser_layout_id
      : "1",
    selectedScreens: location.state?.screens
      ? location.state.screens
      : location.state?.track
      ? location.state
      : [],
    PostStatus: location.state?.txt_post_status
      ? location.state?.txt_post_status
      : "false",
    PostTitle: location.state?.txt_post_title
      ? location.state?.txt_post_title
      : "",
    finalfile: location.state?.finalfile ? location.state.finalfile : null,
    selectedDuration: location.state?.txt_post_duration
      ? location.state?.txt_post_duration
      : [],
    radiobuttonvalue: "Day wise",
  });

  const posttype = useRef();

  const [sidebarrowdata, setsidebarrowdata] = useState(
    location.state?.sidebar ? location.state?.sidebar : []
  );

  const [footerrowdata, setfooterrowdata] = useState(
    location.state?.footer ? location.state?.footer : []
  );

  const handleChangeSelectedLayout = (value) => {
    setdata({
      ...data,
      selectedLayout: value,
    });
  };
  const handleChangeRadioButtonvalue = (value) => {
    setdata({
      ...data,
      radiobuttonvalue: value,
    });
  };

  const handleChangeselectedScreens = (value) => {
    setdata({
      ...data,
      selectedScreens: value,
    });
  };

  const handleChangeselectedDuration = (value) => {
    setdata({
      ...data,
      selectedDuration: value,
    });
  };

  const handleChangefinalfile = (value) => {
    console.log("updated value new", value)
    setdata({
      ...data,
      finalfile: value,
    });
  };

  const handleChangePosttitle = (value) => {
    setdata({
      ...data,
      PostTitle: value,
    });
  };

  const handleChangePostStatus = (value) => {
    setdata({
      ...data,
      PostStatus: value,
    });
  };

  useEffect(() => {

    // console.log("Wahaj mag =", location.state)
    // console.log("Wahaj mag =", location.finalfile)
    if (location.state === null) {
      navigate("/posts");
    }
  }, [location, navigate]);

  const filterByReference = (arr1, arr2) => {
    let res = [];
    res = arr1.filter((el) => {
      return arr2.find((element) => {
        return element.ser_screen_id === el.value;
      });
    });
    return res;
  };

  const handleSave = async () => {
    switch (data.selectedLayout) {
      case "1":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype?.current?.value === undefined ||
          posttype?.current?.value === "undefined" ||
          posttype?.current?.value === null ||
          posttype?.current?.value === "null" ||
          posttype?.current?.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype?.current?.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration === "" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            sidebar: "N/A",
            footer: "N/A",
          };

          const payload = JSON.stringify(createpostdata);
          CreatePost(payload);
        }
        break;
      case "2":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            sidebar: "N/A",
            footer: footerrowdata,
          };

          const payload = JSON.stringify(createpostdata);
          CreatePost(payload);
        }

        break;
      case "3":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            sidebar: sidebarrowdata,
            footer: "N/A",
          };
          const payload = JSON.stringify(createpostdata);
          CreatePost(payload);
        }
        break;
      case "4":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
          };

          const payload = JSON.stringify(createpostdata);
          CreatePost(payload);
        }
        break;
      case "5":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            sidebar: sidebarrowdata,
            footer: "N/A",
          };
          const payload = JSON.stringify(createpostdata);
          CreatePost(payload);
        }
        break;
      case "6":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const createpostdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
          };
          const payload = JSON.stringify(createpostdata);
          CreatePost(payload);
        }
        break;
      default:
        toast.error("Please Select the right Layout");
    }
  };
  const handlePreview = async () => {
    // const previewdata = {
    //   ser_layout_id: data.selectedLayout,
    //   txt_post_title: data.PostTitle,
    //   post_type: posttype?.current?.value,
    //   txt_post_duration: data.selectedDuration,
    //   txt_post_status: data.PostStatus,
    //   ser_media_id: data.finalfile?.ser_media_id,
    //   screens: data.selectedScreens,
    //   sidebar: sidebarrowdata,
    //   footer: footerrowdata,
    //   finalfile: data.finalfile,
    //   from: 'addnewpost'

    // };

    switch (data.selectedLayout) {
      case "1":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else {
          // const createpostdata = {
          //   txt_customer_id: localStorage.getItem("txt_customer_id"),
          //   security_token: await GetCookie("es_token"),
          //   ser_layout_id: data.selectedLayout,
          //   txt_post_title: data.PostTitle,
          //   post_type: posttype?.current?.value,
          //   txt_post_duration: posttype?.current?.value === "Image" ? data.selectedDuration : "N/A",
          //   txt_post_status: data.PostStatus,
          //   ser_media_id: data.finalfile?.ser_media_id,
          //   screens: data.selectedScreens,
          //   sidebar: "N/A",
          //   footer: "N/A",
          // };

          const previewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            finalfile: data.finalfile,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            allscreens: location.state.allscreens,
            from: "addnewpost",
          };

          navigate(".", { state: previewdata });
          navigate("/layoutpreview", { state: previewdata });

          // const payload = JSON.stringify(createpostdata);
          // CreatePost(payload)
        }
        break;
      case "2":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const previewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            finalfile: data.finalfile,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            allscreens: location.state.allscreens,
            from: "addnewpost",
          };
          navigate(".", { state: previewdata });
          navigate("/layoutpreview", { state: previewdata });
        }

        break;
      case "3":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const previewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            finalfile: data.finalfile,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            allscreens: location.state.allscreens,
            from: "addnewpost",
          };
          navigate(".", { state: previewdata });

          navigate("/layoutpreview", { state: previewdata });

          // const payload = JSON.stringify(createpostdata);
          // CreatePost(payload)
        }
        break;
      case "4":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const previewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            finalfile: data.finalfile,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            allscreens: location.state.allscreens,
            from: "addnewpost",
          };
          navigate(".", { state: previewdata });

          navigate("/layoutpreview", { state: previewdata });
        }
        break;
      case "5":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else {
          const previewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            finalfile: data.finalfile,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            allscreens: location.state.allscreens,
            from: "addnewpost",
          };
          navigate(".", { state: previewdata });

          navigate("/layoutpreview", { state: previewdata });
        }
        break;
      case "6":
        if (
          data.selectedLayout === undefined ||
          data.selectedLayout === "undefined" ||
          data.selectedLayout === null ||
          data.selectedLayout === "null" ||
          data.selectedLayout === ""
        ) {
          toast.error("Please select the layout");
        } else if (
          data.selectedScreens === undefined ||
          data.selectedScreens === "undefined" ||
          data.selectedScreens === null ||
          data.selectedScreens === "null" ||
          data.selectedScreens.length === 0
        ) {
          toast.error("Please select the screen");
        } else if (
          data.PostTitle === undefined ||
          data.PostTitle === "undefined" ||
          data.PostTitle === null ||
          data.PostTitle === "null" ||
          data.PostTitle === ""
        ) {
          toast.error("Please add the post title");
        } else if (
          data.PostStatus === undefined ||
          data.PostStatus === "undefined" ||
          data.PostStatus === null ||
          data.PostStatus === "null" ||
          data.PostStatus === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          data.finalfile === undefined ||
          data.finalfile === "undefined" ||
          data.finalfile === null ||
          data.finalfile === "null"
        ) {
          toast.error("Please select the file");
        } else if (
          posttype.current.value === undefined ||
          posttype.current.value === "undefined" ||
          posttype.current.value === null ||
          posttype.current.value === "null" ||
          posttype.current.value === ""
        ) {
          toast.error("Please add the post type");
        } else if (
          posttype.current.value === "Image" &&
          (data.selectedDuration === undefined ||
            data.selectedDuration === "undefined" ||
            data.selectedDuration === null ||
            data.selectedDuration === "null" ||
            data.selectedDuration === "N/A" ||
            data.selectedDuration.length === 0)
        ) {
          toast.error("Please select Duration");
        } else if (
          sidebarrowdata === undefined ||
          sidebarrowdata === "undefined" ||
          sidebarrowdata === null ||
          sidebarrowdata === "null" ||
          sidebarrowdata.length === 0
        ) {
          toast.error("Please add the sidebar");
        } else if (
          footerrowdata === undefined ||
          footerrowdata === "undefined" ||
          footerrowdata === null ||
          footerrowdata === "null" ||
          footerrowdata.length === 0
        ) {
          toast.error("Please add the footer");
        } else {
          const previewdata = {
            txt_customer_id: localStorage.getItem("txt_customer_id"),
            security_token: await GetCookie("es_token"),
            ser_layout_id: data.selectedLayout,
            txt_post_title: data.PostTitle,
            post_type: posttype?.current?.value,
            txt_post_duration:
              posttype?.current?.value === "Image" ||
              posttype?.current?.value === "Widget"
                ? data.selectedDuration
                : "N/A",
            txt_post_status: data.PostStatus,
            ser_media_id: data.finalfile?.ser_media_id,
            screens: data.selectedScreens,
            finalfile: data.finalfile,
            sidebar: sidebarrowdata,
            footer: footerrowdata,
            allscreens: location.state.allscreens,
            from: "addnewpost",
          };
          navigate(".", { state: previewdata });
          navigate("/layoutpreview", { state: previewdata });
        }
        break;
      default:
        toast.error("Please Select the right Layout");
    }
  };
  const CreatePost = async (createPostdata) => {
    try {
      const response = await createPost(createPostdata).unwrap();
      if (
        response.message === "Post saved successfully" &&
        response.connection === "true" &&
        response.status === "true"
      ) {
        toast.success(response.message);
        const screens = filterByReference(
          location.state.allscreens,
          data.selectedScreens
        );
        navigate("/posts", { state: screens });
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.error);
    }
  };
  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
        {/* add post form layout selection*/}
        <LayoutSelectionSlider
          data={data}
          handleChangeSelectedLayout={handleChangeSelectedLayout}
        />
        {/* add post form Middle form*/}
        <AddPostMiddleForm
          posttype={posttype}
          data={data}
          handleChangeselectedScreens={handleChangeselectedScreens}
          handleChangeselectedDuration={handleChangeselectedDuration}
          handleChangefinalfile={handleChangefinalfile}
          handleChangePosttitle={handleChangePosttitle}
          handleChangePostStatus={handleChangePostStatus}
        />
        {/* add post form sidebar*/}
        {(data?.selectedLayout === "3" ||
          data?.selectedLayout === "4" ||
          data?.selectedLayout === "5" ||
          data?.selectedLayout === "6") === true ? (
          <LayoutSidebar
            data={data}
            handleChangeRadioButtonvalue={handleChangeRadioButtonvalue}
            setRowsData={setsidebarrowdata}
            rowsData={sidebarrowdata}
          />
        ) : null}

        {/* add post form footer */}
        {(data?.selectedLayout === "2" ||
          data?.selectedLayout === "4" ||
          data?.selectedLayout === "6") === true ? (
          <LayoutFooter
            data={data}
            handleChangeRadioButtonvalue={handleChangeRadioButtonvalue}
            setRowsData={setfooterrowdata}
            rowsData={footerrowdata}
          />
        ) : null}

        <div className="row justify-content-end mr-1">
          <div className="col-sm-12 col-md-12 col-lg-1 d-flex justify-content-end">
            <Button variant="outlined" onClick={handlePreview} className="capitalized fs-14 fw-bold">
              Preview
            </Button>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-1 d-flex justify-content-end">
            <Button variant="contained" onClick={handleSave} className="capitalized fs-14 fw-bold">
              Save
            </Button>
          </div>
        </div>
      </Box>
    </>
  );
};

export default memo(AddNEWPOST);
